export default __webpack_public_path__ + "static/media/slide1-1.568914f0.jpeg";